export default {
	meta(name, cb, ecb) {
		this.http
			.get('/metadata/meta/' + name, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/metadata', { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/metadata', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb, ecb) {
		this.http
			.get('/metadata/' + id, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb, ecb) {
		this.http
			.delete('/metadata/' + id, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
